import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/prtRptCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		let queryStr = '';
		if (searchParams.partNo !== undefined) {
			queryStr = objectToQueryString({
				partNo: searchParams.partNo,
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/overSrgAltr/v1/overSrgAltrs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateUnit(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/overSrgAltr/v1/status/2/overSrgNo/${param.overSrgNo}`, param);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//조회버튼 클릭시
	async getPartCkuInfo({ searchParams }) {
		let partNo = searchParams.partNo;
		let queryStr = '';
		if (searchParams.ckuNo !== undefined) {
			queryStr = objectToQueryString({
				ckuNo: searchParams.ckuNo,
				speYn: searchParams.speYn,
				partClCd: searchParams.partClCd

			});
		}
		// console.log('queryStr2', `${BASE_URL}/pqy/pcku/partCku/v1/partNo/${partNo}`);
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCku/v1/partNo/${partNo}${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	//저장버튼 클릭시
	async savePartCku({ partNo, lists, formInfo }) {
		try {
			const formData = new FormData();

			this.$sf_toggleLoading(true);
			Object.keys(formInfo).forEach(key => formData.append(key, formInfo[key]));
			// if (this.GuideBoardModalValue.fileList.length > 0)
			// 	this.GuideBoardModalValue.fileList.forEach(element => formData.append('fileList', element.raw));
			// else formData.append('fileList', '');

			var list = {
				partNo: partNo,
				form: form,
				list: lists
			};

			let form = {
				form: formInfo
			};
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/state/1/partNo`, formData);
			// const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${partNo}`, list, form);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	//저장버튼 클릭시
	// async savePartCku2({ formData }) {
	// 	try {
	// 		console.log(formData);
	// 		// const datas = Object.assign(partNo, list, form);
	// 		console.log('datas>>> ', formData);
	// 		// for (var pair of formData.entries()) {
	// 		// 	console.log(pair[0] + ', ' + pair[1]);
	// 		// }

	// 		const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/state/1/partNo`, formData);
	// 		// const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${partNo}`, list, form);
	// 		return response?.data || null;
	// 	} catch (error) {
	// 		throw error.response?.data;
	// 	}
	// }

	// async savePartCku2({ formData }) {
	// 	try {
	// 		console.log(formData);
	// 		// const datas = Object.assign(partNo, list, form);
	// 		console.log('datas>>> ', formData);
	// 		// for (var pair of formData.entries()) {
	// 		// 	console.log(pair[0] + ', ' + pair[1]);
	// 		// }

	// 		const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/state/1/partNo`, formData);
	// 		// const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${partNo}`, list, form);
	// 		return response?.data || null;
	// 	} catch (error) {
	// 		throw error.response?.data;
	// 	}
	// },

	async savePartCku2(formData) {
		// //console.log(formData.get('partNo'));
		// let url = `${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo`;
		// // for (var pair of formData.entries()) {
		// // 	//console.log(pair[0] + ', ' + pair[1]);
		// // }
		// return (
		// 	client
		// 		// .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
		// 		.post(url, formData)
		// 		.then(response => (response && response.data) || null)
		// 		.catch(error => {
		// 			throw error;
		// 		})
		// );

		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 승인 프로세스 수행
	async saveState(stateParams) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${stateParams.partNo}/ckuNo/${stateParams.ckuNo}/affrPrcsId/${stateParams.affrPrcsId}/pgsStCd/${stateParams.pgsStCd}`,
				stateParams
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	//재검사 버튼 클릭시
	async saveReInsp(formData) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${formData.partNo}/ckuNo/${formData.ckuNo}/saveReInsp`
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	//재검사 팝업 버튼 클릭시
	async saveReInspPopup(saveReInspPopup) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCku/v1/status/1/partNo/${saveReInspPopup.partNo}/ckuNo/${saveReInspPopup.ckuNo}/saveReInsp`,
				saveReInspPopup
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	// 종합판정 변경시 DB저장
	async saveChangeJgmtCd(params) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/partCku/v1/status/2/partNo/${params.partNo}/ckuNo/${params.ckuNo}/ovrlJgmtCd?ovrlJgmtCd=${params.ovrlJgmtCd}`,
				params
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartPopupResults({ searchDtlParams, currentPage, pageUnit }) {
		let queryStr = '';
		if (searchDtlParams.partNo !== undefined) {
			queryStr = objectToQueryString({
				partNo: searchDtlParams.partNo,
				cofCd: searchDtlParams.cofCd,
				cofNm: searchDtlParams.cofNm,
				strDt: searchDtlParams.strDt,
				endDt: searchDtlParams.endDt,
				currentPage,
				pageUnit
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCku/v1/pops${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartPopupCommResults({ searchCommParams }) {
		let queryStr = '';
		if (searchCommParams.partNo !== undefined) {
			queryStr = objectToQueryString({
				partNo: searchCommParams.partNo
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCku/v1/popComms${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 파일다운로드
	async fileDownload(params) {
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//바코드 입력 조회
	async getSearchBarcodeData({ barCodeParams }) {
		//console.log('barCodeParams >>> ', barCodeParams);
		let partNo = barCodeParams.partNo;
		let queryStr = '';
		queryStr = objectToQueryString({
			bcdPartNo: barCodeParams.bcdPartNo,
			partNo: barCodeParams.partNo,
			lotFromNo: barCodeParams.lotFromNo,
			lotToNo: barCodeParams.lotToNo,
			cofCd: barCodeParams.cofCd,
			cofNm: barCodeParams.cofNm,
			bcdLblId: barCodeParams.bcdLblId,
			speYn:barCodeParams.sYn
		});
		// console.log('queryStr2', `${BASE_URL}/pqy/pcku/partCku/v1/partNo/${partNo}`);
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCku/v1/barcodeSch${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
